import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { cmsApi } from '../lib/api';

export function usePage(slug: string) {
  return useQuery({
    queryKey: ['page', slug],
    queryFn: async () => {
      const res = await cmsApi.getPage(slug);
      return res.data;
    },
    enabled: !!slug,
  });
}

export function usePages() {
  return useQuery({
    queryKey: ['pages'],
    queryFn: async () => {
      const res = await cmsApi.getPages();
      return res.data;
    },
  });
}

export function useSettings() {
  return useQuery({
    queryKey: ['settings'],
    queryFn: async () => {
      const res = await cmsApi.getSettings();
      return res.data;
    },
  });
}

export function useStats() {
  return useQuery({
    queryKey: ['stats'],
    queryFn: async () => {
      const res = await cmsApi.getStats();
      return res.data;
    },
  });
}

export function useSubmitContact() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (data: { name: string; email: string; phone?: string; subject?: string; message: string }) => {
      const res = await cmsApi.submitContact(data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contacts'] });
    },
  });
}
